import { useNavigate } from "react-router-dom";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";

export const gitchaAppUrl = (path) => {
  const domain = String(process.env.REACT_APP_GITCHA_APP_DOMAIN || "").replace(/\/$/, "");
  return domain && path ? `${domain}${path}` : null;
};

export const gitchaBioUrl = (slug) => (slug ? gitchaAppUrl(`/agent-info/${encodeURIComponent(slug)}`) : null);

export const useAgentBioLink = () => {
  const navigate = useNavigate();
  const { isGitchaDefaultWebsite, mls } = useCurrentWebsite();
  const onBls = Boolean(mls) && !isGitchaDefaultWebsite;

  const bioHref = (slug) => (onBls ? gitchaBioUrl(slug) : null) || `/agent-info/${slug}`;

  const openBio = (slug, state) => {
    const external = onBls ? gitchaBioUrl(slug) : null;
    if (external) {
      window.open(external, "_blank", "noopener,noreferrer");
      return;
    }
    navigate(`/agent-info/${slug}`, state ? { state } : undefined);
  };

  return { openBio, bioHref, opensGitcha: onBls && Boolean(gitchaBioUrl("x")) };
};
